import styles from '@components/components/CmsComponents/components/CmsMainTeaser/CallToActionCard/CallToActionCard.module.scss';
import { trackInteraction } from '@components/hooks';
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardBody,
  Heading,
  Image,
  Link,
  getHeadingTag,
} from '@wienenergiegithub/ui-next';

const CallToActionCard = ({
  headingLevel = 4,
  link,
  interactionId,
  image,
  ctaTitle,
}) => (
  <Card>
    <CardBody className={styles.container}>
      <Heading
        as={getHeadingTag(headingLevel)}
        className={styles.heading}
        size="h4"
      >
        {ctaTitle}
      </Heading>
      {image && <Image {...image} {...(link || {})} className={styles.image} />}
      {!!link && (
        <Button
          className={styles.button}
          isElevated
          onClick={() => {
            trackInteraction(interactionId);
          }}
          render={<Link target={link.target} to={link.url} />}
        >
          {link.title}
        </Button>
      )}
    </CardBody>
  </Card>
);

CallToActionCard.propTypes = {
  ctaTitle: PropTypes.string,
  headingLevel: PropTypes.number,
  image: PropTypes.shape({
    title: PropTypes.string,
    alt: PropTypes.string,
    src: PropTypes.string,
    srcSet: PropTypes.string,
    caption: PropTypes.string,
    height: PropTypes.number,
    width: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
    sizes: PropTypes.object,
  }),
  interactionId: PropTypes.string,
  link: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.string,
  }),
};

export default CallToActionCard;
